export const PREFIX_KEY = "smash_";

// Local Storage KEY
export const LS_TOKEN_KEY = PREFIX_KEY + "token_user";
export const LS_TOKEN_CONSUMER_KEY = PREFIX_KEY + "token_consumer_user";
export const LS_USER_KEY = PREFIX_KEY + "user_json";
export const LS_USER_CONSUMER_KEY = PREFIX_KEY + "user_consumer_json";

export const BASE_URL_API = "https://smash-api.neumann.abinsula.com/";
export const URL_API_USER_LOGIN = BASE_URL_API + "login/";
export const URL_API_USERS = BASE_URL_API + "users/";
export const URL_API_RELATIVE_TRANSACTIONS = "/transactions";
export const URL_API_RELATIVE_STATEMENT = "/statement";
export const URL_API_INVOICE_CREDITS = "/invoice-credits/";

export const MONTH_LIST = [
    {value: null, name: "Tutti"},
    {value: 1, name: "Gennaio"},
    {value: 2, name: "Febbraio"},
    {value: 3, name: "Marzo"},
    {value: 4, name: "Aprile"},
    {value: 5, name: "Maggio"},
    {value: 6, name: "Giugno"},
    {value: 7, name: "Luglio"},
    {value: 8, name: "Agosto"},
    {value: 9, name: "Settembre"},
    {value: 10, name: "Ottobre"},
    {value: 11, name: "Novembre"},
    {value: 12, name: "Dicembre"},
]